export interface FormShareChannelConfig {
  id: string;
  label: string;
  iconName?: string;
  utmSource: string;
}

export enum FormShareSourceLabel {
  whatsapp = 'WhatsApp',
  instagram = 'Instagram',
  facebook = 'Facebook',
  website = 'Website',
  direct = 'Direct'
}

export const FORM_SHARE_TRACKED_CHANNELS: FormShareChannelConfig[] = [
  {
    id: 'whatsapp',
    label: FormShareSourceLabel.whatsapp,
    iconName: 'whatsapp-logo',
    utmSource: 'whatsapp'
  },
  {
    id: 'instagram',
    label: FormShareSourceLabel.instagram,
    iconName: 'instagram-logo',
    utmSource: 'instagram'
  },
  {
    id: 'facebook',
    label: FormShareSourceLabel.facebook,
    iconName: 'facebook-logo',
    utmSource: 'facebook'
  },
  {
    id: 'website',
    label: FormShareSourceLabel.website,
    iconName: 'website-logo',
    utmSource: 'website'
  },
  {
    id: 'direct',
    label: FormShareSourceLabel.direct,
    iconName: 'link-green',
    utmSource: 'direct'
  }
];
